import React, { useEffect, useRef, useState } from 'react';
import { useTemplateModel } from '@/store/models/template-model';
import './index.less';
import classNames from 'classnames';
import { InputRef } from 'antd';
import { Input, Tooltip } from '@meitu/saas-ui';
import { getMonthToMinutes } from '@meitu/saas-editor-core/es/utils/common-kit';
import IconFont from '@meitu/xdesign-icon-font';

const DEFAULT_NAME = '未命名的设计';

const TemplateName = () => {
    const [editStatus, setEditStatus] = useState(false);
    const setTemplateName = useTemplateModel((state) => state.setTemplateName);
    const templateName = useTemplateModel((state) => state.templateName);
    const [name, setName] = useState<string>(templateName);

    const inputRef = useRef<InputRef>(null);
    const oldValueRef = useRef<string>('');

    if (!oldValueRef.current) {
        oldValueRef.current = templateName;
    }
    const saveFileName = (e: React.ChangeEvent<HTMLInputElement>) => {
        setEditStatus(false);
        if (oldValueRef.current === e.target.value) return;
        setTemplateName(inputRef.current?.input?.value || `${DEFAULT_NAME}${getMonthToMinutes()}`);

        oldValueRef.current = inputRef.current?.input?.value || `${DEFAULT_NAME}${getMonthToMinutes()}`;
    };
    const onchangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setName(e.target.value);
    };

    const onBlurInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        saveFileName(e);
    };
    const enterHandle = (e: any) => {
        if (e.keyCode === 13) {
            saveFileName(e);
        }
    };
    useEffect(() => {
        if (editStatus) {
            inputRef.current && inputRef.current.focus();
        } else {
            inputRef.current && inputRef.current.blur();
        }
    }, [editStatus]);

    useEffect(() => {
        oldValueRef.current = templateName;
        setName(templateName);
        // document.title = `${templateName}_编辑页_美图设计室`;
    }, [templateName]);
    const handleEdit = () => {
        setEditStatus(true);
    };
    const handelClick = () => {};
    return (
        <div
            style={{
                maxWidth: '232px',
                display: 'flex',
            }}
        >
            <div
                className={classNames('m-template-name', {
                    active: editStatus,
                })}
            >
                <div
                    className="m-template-name__tooltip"
                    style={{
                        visibility: editStatus ? 'hidden' : 'initial',
                    }}
                    onClick={handelClick}
                >
                    <Tooltip placement="bottom" title="重命名">
                        <p className="m-template-name__text" onClick={handleEdit}>
                            {name}
                        </p>
                    </Tooltip>

                    {name ? (
                        <div
                            onClick={handleEdit}
                            style={{
                                visibility: !editStatus ? 'visible' : 'hidden',
                                paddingRight: '8px',
                            }}
                        >
                            <IconFont fontSize={16} name="EditBold" />
                        </div>
                    ) : null}
                </div>

                <Input
                    className="m-template-name__input"
                    value={name}
                    onChange={onchangeInput}
                    onBlur={onBlurInput}
                    ref={inputRef}
                    maxLength={30}
                    onKeyDown={enterHandle}
                    style={{
                        visibility: !editStatus ? 'hidden' : 'initial',
                    }}
                />
            </div>
        </div>
    );
};

export default React.memo(TemplateName);
